import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MapView from './pages/MapView';
import AdminPanel from './pages/AdminPanel';
import EventDetail from './pages/EventDetail';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MapView />} />
        <Route path="/events/:slug" element={<EventDetail />} />
        <Route path="/admin/*" element={<AdminPanel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
